import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await login(email, password);

      const from = location.state?.from || "/";

      navigate(from, { replace: true });
    } catch (err) {
      console.error("Login failed:", err);
      setError(err.response?.data?.message || err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="!bg-[#008080]">
      <div className="!flex !flex-col !items-center !justify-center !px-6 !py-8 !mx-auto md:!h-screen lg:!py-0 min-h-screen">
        <p className="!flex !items-center !mb-6 !text-4xl !font-bold !text-white">Real Estate</p>

        <div className="!w-full !bg-white !rounded-lg !shadow md:!mt-0 sm:!max-w-md xl:!p-0 !border !border-gray-300">
          <div className="!p-6 !space-y-4 md:!space-y-6 sm:!p-8">
            <h1 className="!text-xl !font-bold !leading-tight !tracking-tight !text-gray-900 md:!text-2xl">Sign in</h1>

            {error && <div className="!bg-red-100 !text-red-700 !p-2 !rounded !text-sm">{error}</div>}

            <form className="!space-y-4 md:!space-y-6" onSubmit={handleLogin}>
              <div>
                <label htmlFor="email" className="!block !mb-2 !text-sm !font-medium !text-gray-900 !text-left !w-full">
                  Email
                </label>
                <input type="email" id="email" className="!bg-gray-50 !border !border-gray-300 !text-gray-900 !rounded-lg focus:!outline-[#008080] !block !w-full !p-2.5" placeholder="name@company.com" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>

              <div>
                <label htmlFor="password" className="!block !mb-2 !text-sm !font-medium !text-gray-900 !text-left !w-full">
                  Password
                </label>
                <input type="password" id="password" placeholder="••••••••" className="!bg-gray-50 !border !border-gray-300 !text-gray-900 !rounded-lg focus:!outline-[#008080]  !block !w-full !p-2.5" value={password} onChange={(e) => setPassword(e.target.value)} required />
              </div>

              <button type="submit" disabled={loading} className="!w-full !text-white !bg-[#008080] hover:!bg-[#257676] ease-in-out transition-all duration-100 focus:!outline-none !font-medium !rounded-lg !text-sm !px-5 !py-2.5 !text-center disabled:!bg-[#3c5063] !cursor-pointer disabled:!cursor-not-allowed ">
                {loading ? "Logging in..." : "Sign in"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
